import { siteContent } from '@/mocks/pt/siteContent';

export default function FaqSection() {
  const { faq } = siteContent;

  const categoryColors = [
    'bg-accent-100',
    'bg-secondary-100',
    'bg-accent-100',
    'bg-secondary-100',
    'bg-accent-100',
    'bg-secondary-100',
  ];

  return (
    <section className="px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <span className="inline-block px-4 py-1.5 text-xs font-semibold bg-secondary-200 text-secondary-800 rounded-full mb-5 whitespace-nowrap">
          {faq.label}
        </span>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-10 md:mb-12 leading-tight">
          {faq.title}
        </h2>

        {/* FAQ Grid - 3 columns masonry style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {faq.questions.map((q, i) => (
            <div
              key={q.id}
              className={`bg-background-50 rounded-lg p-5 md:p-6 ${
                i % 3 === 0 ? 'lg:mt-0' : i % 3 === 1 ? 'lg:mt-6' : 'lg:mt-3'
              }`}
            >
              {/* Header */}
              <div className="flex items-start gap-3 mb-4">
                <div className={`w-9 h-9 rounded-full ${categoryColors[i % categoryColors.length]} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-xs font-bold text-foreground-700">{q.id}</span>
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 leading-snug">
                    {q.question}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{q.category}</p>
                </div>
              </div>

              {/* Answer */}
              <p className="text-sm text-foreground-600 leading-relaxed">
                {q.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}